import { useState } from 'react';
import { Title, message } from 'ui';
import { LinkWasSent, PasswordLessLoginForm } from '../components';
import { useRequestMagicLinkQuery } from '../queries';

type P<T extends { referrer?: string }> = {
  onNavigateToPrimaryLogin: () => Promise<void>;
  onReplaceCheckMagicLink: () => Promise<void>;
  state?: T;
};

const PasswordlessLogin = <T extends { referrer?: string }>({
  onNavigateToPrimaryLogin,
  onReplaceCheckMagicLink,
  state,
}: P<T>) => {
  const { isPending: isRequestLoading, mutate: requestMagicLink } = useRequestMagicLinkQuery();

  const [wasSent, setWasSent] = useState({
    email: '',
    wasSent: false,
  });

  const onSubmit = (submitData: { email: string }) => {
    requestMagicLink(
      { ...submitData, referrer: state?.referrer },
      {
        onError() {
          message.error('Something went wrong, please try again later.');
        },
        onSuccess() {
          setWasSent({ email: submitData.email, wasSent: true });
        },
      },
    );
  };

  const requestAnotherMagicLink = () => {
    onSubmit({ email: wasSent.email });
  };

  return (
    <>
      {wasSent.wasSent ? (
        <LinkWasSent
          isRequestLoading={isRequestLoading}
          onReplaceCheckMagicLink={onReplaceCheckMagicLink}
          onUserClickBack={onNavigateToPrimaryLogin}
          requestAnotherMagicLink={requestAnotherMagicLink}
        />
      ) : (
        <>
          <Title level={1} marginBottom>
            Send email link
          </Title>
          <div className="onboarding-passwordless-login__form-wraper">
            <PasswordLessLoginForm
              loading={isRequestLoading}
              onNavigateToPrimaryLogin={onNavigateToPrimaryLogin}
              onSubmit={onSubmit}
            />
          </div>
        </>
      )}
    </>
  );
};

export default PasswordlessLogin;
